import { createApiClient } from '@wix/premium-fed-sdk/@apis-infra-react';
import { DealerQueriesConfig } from './dealer.queries';
export const DealerApiClient = createApiClient(DealerQueriesConfig);
//# sourceMappingURL=dealer.api-client.js.map